'use strict';

var maxSlots = parseInt($('.compare-bar').data('max-slots'), 10);
var productsForComparison = [];
var compareTitleText = $('.compare-title-text').text() || $('.compare-title').text();
var location = window.location;
var history = window.history;
var lastKnownUrl = location.href;
var isCompareHandlersBound = false;
var isCompareBarHandlersBound = false;
var pendingCompareBarShow = false;

/**
 * Check for compare checkbox inputs on page.
 *
 * @return {boolean} Whether compare inputs exist.
 */
function hasCompareInputs() {
    return $('.compare input[type=checkbox]').length > 0;
}

/**
 * Check for compare bar container on page.
 *
 * @return {boolean} Whether compare bar exists.
 */
function hasCompareBar() {
    return $('.compare-bar').length > 0;
}

/**
 * Get the compare bar wrapper element.
 *
 * @return {jQuery} Compare bar wrapper.
 */
function getCompareBar() {
    return $('.compare-bar-wrapper');
}

/**
 * Safely grab tile image src/alt, accounting for lazyloaded images
 *
 * @param {jQuery} $tile - product tile element
 * @return {{src: string, alt: string}} - image data
 */
function getTileImageData($tile) {
    var $img = $tile.find('img.tile-image').first();
    return {
        src:
            $img.attr('data-src') ||
            $img.prop('currentSrc') ||
            $img.attr('src') ||
            '',
        alt: $img.attr('alt') || ''
    };
}

/**
 * Get compare data from checkbox data attributes with DOM fallbacks
 *
 * @param {jQuery} $checkbox - compare checkbox element
 * @return {{imgSrc: string, altText: string, productName: string, price: string, formattedPrice: string}} - data
 */
function getCompareData($checkbox) {
    var $tile = $checkbox.closest('.product-tile');
    var imageData = getTileImageData($tile);
    var imgSrc = $checkbox.data('imgSrc') || imageData.src;
    var altText = $checkbox.data('imgAlt') || imageData.alt;
    var productName =
        $checkbox.data('productName') ||
        $tile.find('.pdp-link').text();
    var price =
        $checkbox.data('price') ||
        $tile.find('.price').find('span.sales').find('span.value').attr('content');
    var formattedPrice =
        $checkbox.data('formatted-price') ||
        $tile.find('.price').find('span.sales').find('span.value').attr('formatted-price');
    return {
        imgSrc: imgSrc || '',
        altText: altText || '',
        productName: (productName || '').trim(),
        price: price || '',
        formattedPrice: (formattedPrice || '')
    };
}

/**
 * @typedef ProductComparisonList
 * @type Object
 * @property {string} pid - ID for product to compare
 * @property {string} imgSrc - Image URL for selected product
 */

/**
 * Compiles the HTML for a single slot
 *
 * @param {ProductComparisonList} product - Selected product to compare
 * @param {number} idx - Slot number (zero-based)
 * @return {string} - HTML for a single slot
 */
function compileSlot(product, idx) {
    var pid = product.pid;
    var name = 'pid' + idx;
    var productName = product.productName || '';
    var formattedPrice = product.formattedPrice || '';
    var priceDisplay = formattedPrice || '';

    return (
        '' +
        '<div class="slot" data-pid="' +
        pid +
        '">' +
        '<img alt="' +
        (product.altText || productName) +
        '" src="' +
        product.imgSrc +
        '">' +
        '<div class="slot-info">' +
        '<div class="product-name">' +
        productName +
        '</div>' +
        '<div class="product-meta">' +
        '<div class="product-price">' +
        priceDisplay +
        '</div>' +
        '<button type="button" class="close" aria-label="remove ' +
        (product.altText || productName) +
        ' from compare list">' +
        '<i class="fa fa-close" aria-hidden="true"></i>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '<input type="hidden" name="' +
        name +
        '" value="' +
        pid +
        '">' +
        '</div>\n'
    );
}

/**
 * Draw and render the Compare Bar product slots
 *
 * @param {ProductComparisonList []} productsToCompare - List of ID's of the products to compare
 */
function redrawCompareSlots(productsToCompare) {
    var html = productsToCompare
        .map(function (product, idx) {
            return compileSlot(product, idx);
        })
        .join('');

    // Show info label when fewer than 2 products are selected
    if (productsToCompare.length < 2) {
        html +=
            '<div class="compare-bar-message">' +
            $('.compare-bar').data('min-products-msg') +
            '</div>';
    }

    $('.compare-bar .product-slots').empty().append(html);
}

/**
 * Enables/disables the Compare button, depending on whether at least two products have been
 * selected for comparison
 *
 * @param {number} numProducts - Number of products selected for comparison
 */
function setCompareButton(numProducts) {
    var hasTitleCount = $('.compare-title-count').length;

    if (numProducts > 0) {
        // Update count in the new structure
        if (hasTitleCount) {
            $('.compare-title-count').text('(' + numProducts + ')');
        } else {
            $('.compare-title').text(compareTitleText + ' (' + numProducts + ')');
        }
    } else if (hasTitleCount) {
        $('.compare-title-count').text('');
    } else {
        $('.compare-title').text(compareTitleText);
    }
    if (numProducts < 2) {
        $('button.compare').attr('disabled', true);
    } else {
        $('button.compare').removeAttr('disabled');
    }
}

/**
 * Returns a copy of a list of products to compare
 *
 * @param {ProductComparisonList []} productsToCompare - List of ID's of the products to compare
 * @return {ProductComparisonList []} List of ID's of the products to compare
 */
function copyProducts(productsToCompare) {
    return productsToCompare.map(function (product) {
        var proxy = {};

        Object.keys(product).forEach(function (key) {
            proxy[key] = product[key];
        });

        return proxy;
    });
}

/**
 * Handles the selection of a product for comparison
 *
 * @param {ProductComparisonList []} products - List of ID's of the products to compare
 * @param {string} pid - ID for product to compare
 * @param {string} imgSrc - Image URL for selected product
 * @param {string} altText - Alt text for selected product image
 * @param {string} productName - Name of the selected product
 * @param {string} price - Price of the selected product
 * @param {string} formattedPrice - Formatted price of the selected product
 * @return {ProductComparisonList []} List of ID's of the products to compare
 */
function selectProduct(products, pid, imgSrc, altText, productName, price, formattedPrice) {
    var productsToCompare = copyProducts(products) || [];

    if (productsToCompare.length < maxSlots) {
        productsToCompare.push({
            pid: pid,
            imgSrc: imgSrc,
            altText: altText,
            productName: productName,
            price: price,
            formattedPrice: formattedPrice
        });

        if (productsToCompare.length === maxSlots) {
            $('input[type=checkbox]:not(:checked)').attr('disabled', true);
        }

        redrawCompareSlots(productsToCompare);
        setCompareButton(productsToCompare.length);
        if (getCompareBar().length) {
            getCompareBar().show();
        } else {
            pendingCompareBarShow = true;
        }
    }

    return productsToCompare;
}

/**
 * Handles the deselection of a product
 *
 * @param {ProductComparisonList []} products - List of ID's of the products to compare
 * @param {string} pid - ID for product to compare
 * @return {ProductComparisonList []} List of ID's of the products to compare
 */
function deselectProduct(products, pid) {
    var productsToCompare = copyProducts(products) || [];

    productsToCompare = productsToCompare.filter(function (product) {
        return product.pid !== pid;
    });

    if (productsToCompare.length === 0) {
        getCompareBar().hide();
    }

    $('input#' + pid).prop('checked', false);
    $('input[type=checkbox]:not(:checked)').removeAttr('disabled');

    redrawCompareSlots(productsToCompare);
    setCompareButton(productsToCompare.length);
    return productsToCompare;
}

/**
 * Clears the Compare Bar and hides it
 * @return {undefined}
 */
function clearCompareBar() {
    productsForComparison.forEach(function (product) {
        $(this).trigger('compare:deselected', { pid: product.pid });
    });

    productsForComparison = [];
    $('.compare input').prop('checked', false);
    $('.compare input[type=checkbox]:not(:checked)').removeAttr('disabled');
    getCompareBar().hide();

    // Clear hash so refreshed/back state doesn't retain compare selections
    if (location.hash) {
        var urlWithoutHash = location.href.split('#')[0];
        history.replaceState({}, document.title, urlWithoutHash);
        lastKnownUrl = urlWithoutHash;
    }
}

/**
 * Update form action url to not have query string
 * @returns {undefined}
 */
function updateSubmitUrl() {
    var form = $('.compare-products-form');
    var targetUrl = form.attr('action');
    var urlParts = targetUrl.split('?');
    if (urlParts[1]) {
        urlParts[1].split('&').forEach(function (keyValue) {
            var splittedValues = keyValue.split('=');
            var key = decodeURIComponent(splittedValues[0]);
            var value = decodeURIComponent(splittedValues[1]);
            if (key && value) {
                if (form.find('[name="' + key + '"]').length === 0) {
                    form.append(
                        '<input type="hidden" name="' +
                            key +
                            '" value="' +
                            value +
                            '" />'
                    );
                }
            }
        });
        form.attr('action', urlParts[0]);
    }
}

module.exports = {
    /**
     * Handles Compare checkbox click
     */
    handleCompareClick: function () {
        if (!hasCompareInputs()) {
            return;
        }
        $('div.page').on('click', '.compare input[type=checkbox]', function () {
            var pid = $(this).attr('id');
            var checked = $(this).is(':checked');
            var compareData = getCompareData($(this));

            if (checked) {
                productsForComparison = selectProduct(
                    productsForComparison,
                    pid,
                    compareData.imgSrc,
                    compareData.altText,
                    compareData.productName,
                    compareData.price,
                    compareData.formattedPrice
                );
                $(this).trigger('compare:selected', { pid: pid });
            } else {
                productsForComparison = deselectProduct(
                    productsForComparison,
                    pid
                );
                $(this).trigger('compare:deselected', { pid: pid });
            }
        });
    },

    /**
     * Handles the Clear All link
     */
    handleClearAll: function () {
        if (!hasCompareBar()) {
            return;
        }
        $('.compare-bar a.clear-all').on('click', function (e) {
            e.preventDefault();
            clearCompareBar();
        });
    },

    /**
     * Handles deselection of a product on the Compare Bar
     */
    deselectProductOnCompareBar: function () {
        if (!hasCompareBar()) {
            return;
        }
        $('.compare-bar').on('click', '.close', function () {
            var pid = $(this).closest('.slot').data('pid').toString();
            productsForComparison = deselectProduct(productsForComparison, pid);
            $(this).trigger('compare:deselected', { pid: pid });
        });
    },

    /**
     * Selects products for comparison based on the checked status of the Compare checkboxes in
     * each product tile.  Used when user goes back from the Compare Products page.
     */
    selectCheckedProducts: function () {
        if (!hasCompareInputs()) {
            return;
        }
        $('.product-grid').ready(function () {
            if (!location.hash && $('.compare input:checked').length === 0) {
                return;
            }
            if (location.hash) {
                location.hash
                    .replace('#', '')
                    .split(',')
                    .forEach(function (id) {
                        $('input#' + id).prop('checked', 'checked');
                    });
            }
            $('.compare input:checked').each(function () {
                var pid = $(this).prop('id');
                var compareData = getCompareData($(this));

                productsForComparison = selectProduct(
                    productsForComparison,
                    pid,
                    compareData.imgSrc,
                    compareData.altText,
                    compareData.productName,
                    compareData.price
                );
                $(this).trigger('compare:selected', { pid: pid });
            });
        });
    },

    /**
     * Sets the "backUrl" property to the last attribute selected URL to ensure that when the user
     * goes back from the Compare Products page, the previously selected attributes are still
     * selected and applied to the previous search.
     */
    setBackUrl: function () {
        if (!$('.search-results').length) {
            return;
        }
        $('.search-results').on('click', '.refinements a', function () {
            $('input[name="backUrl"]').val($(this).prop('href'));
        });
    },

    /**
     * Sets the history.pushState for history.back() to work from the Compare Products page.
     */
    setPushState: function () {
        if (!$('.compare-products-form').length) {
            return;
        }
        $('.compare-products-form').on('submit', function () {
            updateSubmitUrl();
            var selectedProducts = $('.compare input:checked')
                .map(function () {
                    return this.id;
                })
                .get()
                .join(',');
            history.pushState(
                {},
                document.title,
                lastKnownUrl + '#' + selectedProducts
            );
            location.hash = selectedProducts;

            $(this)
                .find('input[name="cgid"]')
                .attr('value', $('input.category-id').val());
        });
    },

    catchFilterChange: function () {
        if (!$('.container').length) {
            return;
        }
        $('.container').on(
            'click',
            '.refinements li a, .refinement-bar a.reset',
            function (e) {
                e.preventDefault();
                clearCompareBar();
            }
        );
    },
    listenToFilterChange: function () {
        if (!$('body').length) {
            return;
        }
        $('body').on('search:filter', function () {
            // Use current browser location (which is updated via pushState when filters are applied)
            // This ensures we use the SEO URL, not the AJAX endpoint URL from the button's data-href
            setTimeout(function () {
                lastKnownUrl = location.href.split('#')[0];
            }, 0);
        });
    },

    /**
     * Handles collapse/expand of the compare tray
     */
    handleCompareBarToggle: function () {
        if (!hasCompareBar()) {
            return;
        }
        getCompareBar().on('click', '.compare-header, .compare-bar-toggle', function (e) {
            e.stopPropagation();
            var isCollapsed = getCompareBar().toggleClass('is-collapsed').hasClass('is-collapsed');
            $('.compare-bar-toggle').attr('aria-expanded', (!isCollapsed).toString());
        });
    }
};

/**
 * Run a callback when the browser is idle.
 *
 * @param {Function} callback - Task to run.
 * @return {void}
 */
function runWhenIdle(callback) {
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 500 });
    } else {
        setTimeout(callback, 0);
    }
}

/**
 * Bind compare checkbox and compare bar handlers once.
 *
 * @return {void}
 */
function bindEarlyHandlers() {
    if (!isCompareHandlersBound) {
        isCompareHandlersBound = true;
        $(document).on('click', '.compare input[type=checkbox]', function () {
            var pid = $(this).attr('id');
            var checked = $(this).is(':checked');
            var compareData = getCompareData($(this));

            if (checked) {
                productsForComparison = selectProduct(
                    productsForComparison,
                    pid,
                    compareData.imgSrc,
                    compareData.altText,
                    compareData.productName,
                    compareData.price,
                    compareData.formattedPrice
                );
                $(this).trigger('compare:selected', { pid: pid });
            } else {
                productsForComparison = deselectProduct(productsForComparison, pid);
                $(this).trigger('compare:deselected', { pid: pid });
            }
        });
    }

    if (!isCompareBarHandlersBound) {
        isCompareBarHandlersBound = true;
        $(document).on('click', '.compare-bar a.clear-all', function (e) {
            e.preventDefault();
            clearCompareBar();
        });
        $(document).on('click', '.compare-bar .close', function () {
            var pid = $(this).closest('.slot').data('pid').toString();
            productsForComparison = deselectProduct(productsForComparison, pid);
            $(this).trigger('compare:deselected', { pid: pid });
        });
        $(document).on('click', '.compare-bar-wrapper .compare-header, .compare-bar-wrapper .compare-bar-toggle', function (e) {
            e.stopPropagation();
            var $bar = getCompareBar();
            if (!$bar.length) {
                return;
            }
            var isCollapsed = $bar.toggleClass('is-collapsed').hasClass('is-collapsed');
            $('.compare-bar-toggle').attr('aria-expanded', (!isCollapsed).toString());
        });
    }
}

module.exports.initEarly = function () {
    bindEarlyHandlers();
};

module.exports.init = function () {
    if (!hasCompareInputs() && !hasCompareBar()) {
        return;
    }

    bindEarlyHandlers();
    module.exports.selectCheckedProducts();

    if (pendingCompareBarShow && getCompareBar().length) {
        getCompareBar().show();
        pendingCompareBarShow = false;
    }

    // Non-critical handlers can be deferred to avoid blocking first paint
    runWhenIdle(function () {
        module.exports.setBackUrl();
        module.exports.setPushState();
        module.exports.catchFilterChange();
        module.exports.listenToFilterChange();
    });
};
